import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    borderBottom: 'none',
    '.page-size-title': {
      display: { xs: 'none', md: 'inline-block' },
      textTransform: 'none',
    },
  },
  paper: { maxHeight: 360 },
});

export default useSx;
